require ('./inc/site.js');
require ('./inc/jquery.selectric.js');

var hasSelect = false;
var filterOpenButton = undefined;
var filterContent = undefined;
var filterButtonContainer = undefined;
var footer = footer;

$(document).ready(function() {
  $('[data-purpose="custom-select-container"] select').selectric({
    'arrowButtonMarkup':'<svg class="icon arrow-down"><use xlink:href="#arrow-down" /></svg>'
  });

  if (hasSelect) {
    $(document).click(function(e){
      $(document).trigger('unnepekaruhaza.body_click', $(e.target));
    });
  }
  footer = $('footer');
  filterContent = $('[data-purpose="filter-content"]');
  filterOpenButton = $('[data-purpose="filter-open-button"]');
  filterButtonContainer = $('[data-purpose="filter-button-container"]');
  if (filterOpenButton.length == 1 && filterContent.length == 1) {
    filterOpenButton.click(function(){
      changeFilterVisiblity();
    });

    filterContent.find('.filter-close-button').click(function(){
      changeFilterVisiblity();
    });

    var scrollFn = function() {
      var border = footer.offset().top;
      var top = filterOpenButton.offset().top;

      if (top >= border && !filterButtonContainer.hasClass('inactive')) {
        filterButtonContainer.addClass('inactive');
      } else if (top < border && filterButtonContainer.hasClass('inactive')) {
        filterButtonContainer.removeClass('inactive');
      }
    }
    window.addEventListener('scroll', scrollFn);
    window.addEventListener('touchend', scrollFn);
	  window.addEventListener('touchmove', scrollFn);
  }
});

function changeFilterVisiblity() {
  if (filterContent && filterOpenButton) {
    if (filterContent.hasClass('opened')) {
      $('body').removeClass('opened-filter');
      filterOpenButton.removeClass('opened-filter');
      filterContent.removeClass('opened');
    } else {
      $('body').addClass('opened-filter');
      filterContent.addClass('opened');
      filterOpenButton.addClass('opened-filter');
    }
  }
}

  $('#order').on('change', function() {
		$('form[name="rendezes"]').trigger('submit');
  });

